import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Badge, Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import Swal from 'sweetalert2';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import Loader from '../../Components/Common/Loader';
import { deleteProjectAPI, getCompanyDetails, getProjectDetail } from '../../apiConfig/apiCall';
import slack from '../../assets/images/brands/slack.png';
import { getProjectCertifications } from '../../slices/ManageClient/thunk';
import AddCertificationModal from './AddCertificationModal';
import AddProject from './AddProject';
import { ComplianceChartCard } from './ComplianceChartCard';
import './project.css';
const ManageProject = () => {

    const apiImageUrl = process.env.REACT_APP_API_IMAGE_URL;

    const params = useParams();
    const CLIENT_ID = params.id;

    const [loading, setLoading] = useState(true);
    const [companyName, setCompanyName] = useState('');
    const [companyImage, setCompanyImage] = useState('');
    const [projectData, setProjectData] = useState({});

    const dispatch = useDispatch();
    const { isLoading, isError, projectCertification } = useSelector(state => state.getProjectCErtificationSlice);

    const [defaultCertificate, setDefaultCertificate] = useState()
    const getProjectDetailData = async (CLIENT_ID) => {
        try {
            const apiResponse = await getProjectDetail(CLIENT_ID);
            const companyNameData = await getCompanyDetails(CLIENT_ID);
            if (companyNameData.status === 200) {
                setCompanyName(companyNameData.data.clientDetails.companyName);
            }
            if (apiResponse.status === 200) {
                setDefaultCertificate(apiResponse.data.projectCertification)
                setProjectData(apiResponse.data);
                setCompanyImage(apiResponse.data.file);
            }
        } catch (error) {
            console.error("Error fetching project details:", error);
        }
    };


    // Delete Project
    const deleteProject = async () => {
        try {
            Swal.fire({
                width: '20rem',
                padding: '0 0 1rem 0',
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.isConfirmed) {
                    deleteProjectAPI(CLIENT_ID)
                        .then(response => {
                            Swal.fire({
                                title: "Deleted!",
                                text: response.data,
                                icon: "success",
                                width: '20rem',
                                padding: '0 0 1rem 0',
                            });
                            dispatch(getProjectCertifications(CLIENT_ID))
                        })
                        .catch(error => {
                            Swal.fire({
                                title: "Error!",
                                text: error,
                                icon: "error",
                                width: '20rem',
                                padding: '0 0 1rem 0',
                            });
                        });
                }
            });
        } catch (error) {
            console.log(error.message);
        }
    }

    const [addCertificateModal, setAddCertificateModal] = useState(false);
    const toggleAddCertificateModal = () => setAddCertificateModal(!addCertificateModal);

    useEffect(() => {
        const fetchData = async () => {
            await getProjectDetailData(CLIENT_ID);
            setLoading(false);
        };
        fetchData();
        dispatch(getProjectCertifications(CLIENT_ID));
    }, [CLIENT_ID, addCertificateModal, dispatch]);


    if (loading) return <Loader />
    if (isLoading) return <Loader />


    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={'Projects'} pageTitle={'Dashboard'} />
                    {
                        projectCertification === "Not found." ? <AddProject
                            defaultCertificate={defaultCertificate}
                        /> :
                            <Row>

                                <Col lg={12} className='pe-1 ps-1'>
                                    <Card className='mb-2'>
                                        <div>
                                            <CardBody className="pb-0 px-4">
                                                <Row className="mb-3">
                                                    <div className="col-md">
                                                        <Row className="align-items-center g-3">
                                                            <div className="col-md-auto">
                                                                <div className="avatar-md">
                                                                    <div className="avatar-title bg-white rounded-circle">
                                                                        <img src={apiImageUrl + companyImage} onError={(e) => { e.target.src = slack }} alt="" className="avatar-xs" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md">
                                                                <div>
                                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                                        <div className='d-flex align-items-center'>
                                                                            <h4 className="fw-bold me-2 mb-0">{companyName}</h4>
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <h4 className="mb-3">Manage CCF</h4>
                                                                        <div className='d-flex align-items-center mb-2'>
                                                                            <Button color='danger' className='btn-sm me-2' onClick={deleteProject}>Delete This Project</Button>

                                                                            <Button color='primary' className='btn-sm' onClick={toggleAddCertificateModal}>Add New Project Certification</Button>
                                                                        </div>
                                                                    </div>

                                                                    <Row>

                                                                        <Col lg={4}>
                                                                            <div className='d-flex align-items-center'><i className="bx bx-user-circle me-1"></i> Project Manager : <span className="fw-600 ms-1">
                                                                                {projectData.projectManager}
                                                                            </span>
                                                                            </div>
                                                                        </Col>

                                                                        <Col lg={4}>
                                                                            <div className='d-flex align-items-center'><i className="bx bx-user-pin me-1"></i> QSA(Auditor) : <span className="fw-600 ms-1">
                                                                                {projectData.dba}
                                                                            </span></div>
                                                                        </Col>

                                                                        <Col lg={4}>
                                                                            <div className='d-flex align-items-center'><i className="bx bxs-calendar me-1"></i>Due Date : <span className="fw-600 ms-1">{projectData.dueDate}</span></div>
                                                                        </Col>
                                                                    </Row>

                                                                </div>
                                                            </div>
                                                        </Row>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </div>
                                    </Card>
                                </Col>
                                <Col lg={12}>
                                    <Row>
                                        {
                                            projectCertification
                                                .filter(data => data.status !== "INACTIVE")
                                                .map((data, index) => (
                                                    <Col key={index} lg={3} sm={6} className="project-card pe-1 ps-1">
                                                        <Card className="card-height-100">
                                                            <CardBody>
                                                                <div className="d-flex flex-column h-100">
                                                                    <div className="d-flex">
                                                                        <div className="flex-grow-1">
                                                                            <p className="text-dark fs-8 mb-4">{data.name}</p>
                                                                        </div>
                                                                        <div className="flex-shrink-0">
                                                                            <Badge color={data.status === "ACTIVE" ? "success" : data.status === "EXPIRING" ? "warning" : data.status === "EXPIRED" ? "danger" : "secondary"}>
                                                                                {data.status}
                                                                            </Badge>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex">
                                                                        <div className="flex-shrink-0 me-3">
                                                                            <div className="avatar-sm">
                                                                                <span className="avatar-title p-2 bg-warning-subtle rounded-border">
                                                                                    <img src={apiImageUrl + data.image} onError={(e) => { e.target.src = slack }} alt="" className="img-fluid p-1 rounded-circle" />
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex-grow-1 d-flex">
                                                                            <div>
                                                                                <h5 className="mb-1 fs-13">QSA(Auditor)</h5>
                                                                                <p className="mb-0">{data.auditorName}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <ComplianceChartCard name={data.name} total={data.total} pending={data.pending} completed={data.completed} />
                                                                </div>
                                                            </CardBody>
                                                            <div className="card-footer bg-transparent border-top-dashed py-2">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="flex-grow-1">
                                                                        <div className="avatar-group d-flex align-items-center">
                                                                            <div>
                                                                                <h6 className="mb-0 fs-12">Due Date</h6>
                                                                                <p className="text-muted mb-0 fs-10">{data.other}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                ))
                                        }
                                    </Row>
                                </Col>
                            </Row>
                    }
                </Container>



                {/* Add Certificate Modal */}
                <AddCertificationModal
                    addCertificateModal={addCertificateModal}
                    toggleAddCertificateModal={toggleAddCertificateModal}
                    defaultCertificate={defaultCertificate}
                />

            </div>
        </>
    )
}

export default ManageProject;